import { useContext } from 'react'
import { GlobalContext } from '../context'

/**
 * 获取language
 */
function useLang() {
  const { lang } = useContext(GlobalContext)

  return lang
}

export default useLang
